export default __webpack_public_path__ + "static/modal-error-desktop-92319cbc9c1647d186101f46f1d0a245.svg";